import React, {useState} from 'react';
import {Table, Divider} from "antd";
import {dataNewlineProc, dataSingleNewlineProc, getGridTableHeight, amountFormatter} from '../Common/util';


/** -------------------------------------------------------------------------- **/
function Item({itemList, riskScoreList, riskGradeList}) {


// 상세 진단결과
const itemColumnData =  [
    {
        title: '분류',
        dataIndex: 'measure_type',
        key: 'measure_type',
        width: '50px',
        align: 'center',
        fixed: 'left',
        colSpan: 2,
        // render: (value, row, index) => {
        //     const obj = {
        //         children : value,
        //         props : {},
        //     }
        //     if(index >- 1 && value == itemList[index - 1]?.measure_type) {
        //         obj.props.rowSpan = 0;
        //     } else {
        //         for (
        //             let i = 0;
        //             index + i != itemList.length &&
        //             value == itemList[index + i]?.measure_type;
        //             i += 1
        //         ) {
        //             obj.props.rowSpan = i + 1;
        //         }
        //     }
        //     return obj;
        // },
        onCell: (rowData, index) => {
            const value = rowData.measure_type;
            const cellProps = {};
            
            // rowSpan 계산
            const calculateRowSpan = () => {
                if (index > 0 && value === itemList[index - 1]?.measure_type) {
                    return 0; // 이전 셀과 합쳐짐
                }
                
                // 같은 값을 가진 연속된 행의 개수 계산
                let count = 1;
                for (let i = index + 1; i < itemList.length; i++) {
                    if (itemList[i]?.measure_type === value) {
                        count++;
                    } else {
                        break;
                    }
                }
                return count;
            };
            
            cellProps.rowSpan = calculateRowSpan();
            
            return cellProps;
        },
    },
    {
        title: '',
        dataIndex: 'measure_cd',
        key: 'measure_cd',
        width: '50px',
        align: 'center',
        fixed: 'left',
        colSpan:0,
    },
    {
        title: '진단 항목',
        dataIndex: 'measure_nm',
        key: 'measure_nm',
        width: '100px',
        align: 'center',
        fixed: 'left',
        onHeaderCell: () => ({ style: { textAlign: 'center' } }),
        render: (value) => <div style={{ textAlign: 'left' }}>{value}</div>,
    },
    {
        title: '중요도',
        dataIndex: 'important_grd',
        key: 'important_grd',
        width: '50px',
        align: 'center',
        fixed: 'left',
    },
    {
        title: '위험도',
        dataIndex: 'risk_score',
        key: 'risk_score',
        width: '50px',
        align: 'center',
        fixed: 'left',
        render: (_ , rowData ) => {
            if(rowData.risk_score > 0){
                return (
                    <span style={{color: 'red', fontWeight: 'bold'}}>
                        {rowData.risk_score}
                    </span>
                )
            }else{
                return (
                    <span style={{color: 'black'}}>
                        {rowData.risk_score}
                    </span>
                );
            }
       }
    },
    {
        title: '현황 및 문제점',
        dataIndex: 'result_desc',
        key: 'result_desc',
        width: '200px',
        align: 'center',
        onHeaderCell: () => ({ style: { textAlign: 'center' } }),
        render: (value) => <div style={{ textAlign: 'left' }}>{dataSingleNewlineProc(value)}</div>,
        // render: (value) => {
        //     return (
        //         <>
        //           {value.replace(/\\/g, '\n').split('\n').map((line, index) => (
        //             <p key={index} style={{margin:'0px'}}>{line}</p>
        //           ))}
        //         </>
        //       );
        // },
    },
    {
        title: '개선방안 및 보호대책',
        dataIndex: 'suggest_desc',
        key: 'suggest_desc',
        width: '200px',
        align: 'center',
        onHeaderCell: () => ({ style: { textAlign: 'center' } }),
        render: (value) => <div style={{ textAlign: 'left' }}>{dataNewlineProc(value)}</div>,
        // render: (value) => {
        //     return (
        //         <>
        //           {value.replace(/\\n/g, '\n').split('\n').map((line, index) => (
        //         //   {value.split('\n').map((line, index) => (
        //             <p key={index} style={{margin:'0px'}}>{line}</p>
        //           ))}
        //         </>
        //       );
        // },
    },
    {
        title: '전체점수',
        dataIndex: 'total_score',
        key: 'total_score',
        width: '50px',
        align: 'center',
    },
    {
        title: '평가점수',
        dataIndex: 'eval_score',
        key: 'eval_score',
        width: '60px',
        align: 'center',

    },
];

    return (
        <>
                <div className="sub_title">
                        {'■ 상세진단 현황'}
                </div>
                <div style={{padding: '0px 10px'}}>
                    <Table columns={itemColumnData}
                        dataSource={itemList}
                        pagination={false}
                        rowKey='measure_cd'
                        bordered size={"small"}
                        className="sub_table"
                        scroll={{
                            x: 300,
                          }}
                        >
                    </Table>
                </div>
        </>
    );
}
export default Item;